module.exports = __webpack_public_path__ + "img/104.6680d5ad.jpg";